import React, {Component} from 'react';
import NumberFormat from 'react-number-format';
import {Decimal} from 'decimal.js';
import {Modal, ModalHeader, ModalBody, ModalFooter,UncontrolledTooltip} from 'reactstrap';
import {validateField} from "../../common/validation";
import {deepCopyObject, showAxiosError} from "../../helper/helper";
import {request} from "../../helper/APIUtils";
import Select from"../../local_node_modules/react-select"
import '../../local_node_modules/react-select/dist/react-select.css';
import {isValidStock} from "../../common/componentValidation";
import {showBaro} from "../../helper/permission";

class StockModal extends Component {

	constructor(props) {
		super(props);
		this.state = {
			error:{},
			modal:false,
			stock:null,
			saveLoading:false
		};
		this.isOpen 	= this.isOpen.bind(this);
		this.onChange 	= this.onChange.bind(this);
		this.saveStock 	= this.saveStock.bind(this);
		this.validateField 	= this.validateField.bind(this);
		this.setWithholdingCode = this.setWithholdingCode.bind(this);
	}

	componentWillMount() {
		let stock = this.props.stock;
		if(stock === null){
			stock={
				alias: "",
				baseUnit: "C62",
				code: "",
				buyersItemIdentification: "",
				manufacturersItemIdentification: "",
				defPricePurchase: 0,
				defPriceSell: 0,
				defaultCurrencyCode: "TRY",
				explanation: "",
				itemType: {recordId:1,itemName:"MAL"},
				kdvSellExemption:null,
				kdvPurchaseExemption:null,
				kdvPurchase: 1,
				kdvSell: 1,
				gvStoppagePurchase: 0,
				gvStoppageSell: 0,
				name: "",
				otv: 0,
				recordId: null,
				stockGroup: 1,
				gtip:"",
				withHoldingCode:"000_0"
			};
		}else if(stock.withHoldingCode){
			this.props.withholdingTypes.map(function (withholdingType) {
				if(stock.withHoldingCode.toString() !== "0" && withholdingType.code === stock.withHoldingCode.toString()){
					stock.withHoldingCode = stock.withHoldingCode.toString() + "_" + withholdingType.percentage.toString();
				}
			});
		}else if(!stock.withHoldingCode){
			stock.withHoldingCode = "000_0";
		}

		this.setState({ modal:this.props.modal,stock:stock,symbol:this.getCurrencySymbol(stock.defaultCurrencyCode)});
	}

	getCurrencySymbol(defaultCurrencyCode){
		let currency = defaultCurrencyCode;
		let index = this.props.currencyCodes.map((currencyCode)=>
			currencyCode.shortCode
		).indexOf(currency);
		let symbol = "";
		if(index !== -1)
			symbol = this.props.currencyCodes[index].symbol;
		return symbol;
	}

	validateField(e) {
		let id = e.target.id;
		let rule = e.target.dataset.vdata;
		let boundary;
		if(id === "gtip" &&	e.target.value > 0){
			boundary = this.props.isGtipRequired===true?"12,12":"0,12";
			rule = "gtip";
		} else {
			boundary = e.target.dataset.vlength;
		}
		let result = validateField(rule, boundary, e.target.value);
		let error = this.state.error;
		error = Object.assign(error, {[id]: result});
		this.setState({error});
	}

	validateClass(id) {
		let error = this.state.error;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let error = this.state.error;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	onChange(e){
		let stock = deepCopyObject(this.state.stock);
		let name=e.target.name;
		let value=e.target.value;
		if(name==="kdvSell" && !(new Decimal(value).eq(new Decimal(0)))) {
			stock.kdvSellExemption = null;
		}
		if(name==="kdvPurchase" && !(new Decimal(value).eq(new Decimal(0)))) {
			stock.kdvPurchaseExemption = null;
		}

		stock[name] = value;
		if(name === "defaultCurrencyCode")
			this.setState({stock:stock,symbol:this.getCurrencySymbol(value)});
		else{
			this.setState({stock});
		}
	}

	saveStock(e){
		e.preventDefault();
		this.setState({saveLoading:true});
		let data = deepCopyObject(this.state.stock);
		let result = isValidStock(data, this.props.isGtipRequired);
		let error = result.error;
		let valid = result.valid;
		if(valid){
			let self= this;
			let params = {
				url:`/stock/save`,
				method:"post",
				data:data
			};
			request(params)
			.then(response => {
				let res = response.data.withHoldingCode.split("_");
				response.data.withHoldingPercent = res[1];
				response.data.withHoldingCode = res[0];
				self.setState({saveLoading:false});
				self.props.listener(response.data,true);
			})
			.catch(function (error) {
				self.setState({saveLoading:false});
				showAxiosError(error);
			});
		}else{
			this.setState({error:error,saveLoading:false});
		}
	}

	isOpen() {
		this.props.listener(this.state.stock,false);
	}

	setWithholdingCode(e){
		let stock = deepCopyObject(this.state.stock);
		stock["withHoldingCode"] = e.value;
		this.setState({withHoldingCode : e});
		this.setState({stock});
	}


	render() {
		return (
			<Modal isOpen={this.state.modal} toggle={this.isOpen} size="lg" backdrop={false}>
				<ModalHeader toggle={this.isOpen}
							 className="justify-content-center">
					<p className="text-center" style={{margin:"0px"}}>Ürün/Hizmet Bilgisi</p>
				</ModalHeader>
				<ModalBody>
					<div className="row" style={{ position: 'relative' }}>
						{!showBaro() &&
						<div className="col-6">
							<div className={"form-group" + this.validateClass("code")}>
								<label className="form-control-label">Satıcı Ürün Kodu*</label>
								<input className="form-control"
									   type="text"
									   data-vlength={showBaro() ? "0,45":"1,45"}
									   id="code"
									   name="code"
									   onBlur={(e)=>this.validateField(e)}
									   onChange={this.onChange}
									   value={this.state.stock.code}/>
								{this.validateMessage("code") !== "" &&
								<UncontrolledTooltip placement="right" target={"code"} delay={0}>
									{this.validateMessage("code")}
								</UncontrolledTooltip>}
							</div>
						</div>
						}
						<div className="col-6">
							<div className={"form-group" + this.validateClass("name")}>
								<label className="form-control-label">Ürün/Hizmet Adı*</label>
								<input className="form-control"
									   type="text"
									   data-vlength="1,255"
									   id="name"
									   name="name"
									   onBlur={(e)=>this.validateField(e)}
									   onChange={this.onChange}
									   value={this.state.stock.name}/>
								{this.validateMessage("name") !== "" &&
								<UncontrolledTooltip placement="right" target={"name"} delay={0}>
									{this.validateMessage("name")}
								</UncontrolledTooltip>}
							</div>
						</div>
						{!showBaro() &&
						<div className="col-6">
							<div className={"form-group" + this.validateClass("buyersItemIdentification")}>
								<label className="form-control-label">Alıcı Ürün Kodu</label>
								<input className="form-control"
									   type="text"
									   data-vlength="0,45"
									   id="buyersItemIdentification"
									   name="buyersItemIdentification"
									   onBlur={(e) => this.validateField(e)}
									   onChange={this.onChange}
									   value={this.state.stock.buyersItemIdentification}/>
								{this.validateMessage("buyersItemIdentification") !== "" &&
								<UncontrolledTooltip placement="right" target={"buyersItemIdentification"} delay={0}>
									{this.validateMessage("buyersItemIdentification")}
								</UncontrolledTooltip>}
							</div>
						</div>
						}
						{!showBaro() &&
							<div className="col-6">
								<div className={"form-group" + this.validateClass("manufacturersItemIdentification")}>
									<label className="form-control-label">Üretici Ürün Kodu</label>
									<input className="form-control"
										   type="text"
										   data-vlength="0,45"
										   id="manufacturersItemIdentification"
										   name="manufacturersItemIdentification"
										   onBlur={(e) => this.validateField(e)}
										   onChange={this.onChange}
										   value={this.state.stock.manufacturersItemIdentification}/>
									{this.validateMessage("manufacturersItemIdentification") !== "" &&
									<UncontrolledTooltip placement="right" target={"manufacturersItemIdentification"}
														 delay={0}>
										{this.validateMessage("manufacturersItemIdentification")}
									</UncontrolledTooltip>}
								</div>
							</div>
						}
						{!showBaro() &&
							<div className="col-6">
								<div className={"form-group" + this.validateClass("baseUnit")}>
									<label className="form-control-label">Ürün/Hizmet Birimi*</label>
									<Select
										id="baseUnit"
										name="baseUnit"
										placeholder="Para Birimi Seçiniz"
										value={this.state.stock.baseUnit}
										clearable={false}
										noResultsText="Sonuç yok"
										onChange={(e)=> e && this.onChange({target:{name:"baseUnit",value:e.value}})}
										options={this.props.unitCodes.map(unitCode => ({
											value: unitCode.shortCode,
											label: unitCode.longCode
										}))}
									/>
									{this.validateMessage("baseUnit") !== "" &&
									<UncontrolledTooltip placement="right" target={"baseUnit"} delay={0}>
										{this.validateMessage("baseUnit")}
									</UncontrolledTooltip>}
								</div>
							</div>
						}
						<div className="col-6">
							<div className={"form-group" + this.validateClass("defaultCurrencyCode")}>
								<label className="form-control-label">Para Birimi*</label>
								<Select
									id="defaultCurrencyCode"
									name="defaultCurrencyCode"
									placeholder="Para Birimi Seçiniz"
									value={this.state.stock.defaultCurrencyCode}
									clearable={false}
									noResultsText="Sonuç yok"
									onChange={(e)=> e && this.onChange({target:{name:"defaultCurrencyCode",value:e.value}})}
									options={this.props.currencyCodes.map(currencyCode => ({
										value: currencyCode.shortCode,
										label: currencyCode.longCode
									}))}
								/>
								{this.validateMessage("defaultCurrencyCode") !== "" &&
								<UncontrolledTooltip placement="right" target={"defaultCurrencyCode"} delay={0}>
									{this.validateMessage("defaultCurrencyCode")}
								</UncontrolledTooltip>
								}
							</div>
						</div>
						{!showBaro() &&
							<div className="col-6">
								<div className={"form-group" + this.validateClass("defPricePurchase")}>
									<label className="form-control-label">Birim Fiyat Alış</label>
									<NumberFormat id="defPricePurchase"
												  value=
												  {(this.props.source && this.props.source==="despatchLines")
													  ?
													    (this.state.stock.defPricePurchase === "0" || this.state.stock.defPricePurchase === 0) ? "" : this.state.stock.defPricePurchase
												  	:
													    this.state.stock.defPricePurchase
												  }
												  allowNegative={false}
												  isNumericString={true}
												  allowEmptyFormatting={false}
												  decimalScale={9}
												  thousandSeparator={'.'}
												  decimalSeparator={','}
												  displayType="input"
												  placeholder="Birim Fiyat Alış"
												  renderText={value => {
													  value.replace(/\./g, ',')
												  }}
												  suffix={this.state.symbol}
												  onValueChange={(e) => this.onChange({
													  target: {
														  value: e.value,
														  name: "defPricePurchase"
													  }
												  })}
												  className="form-control"/>
									{this.validateMessage("defPricePurchase") !== "" &&
									<UncontrolledTooltip placement="right" target={"defPricePurchase"} delay={0}>
										{this.validateMessage("defPricePurchase")}
									</UncontrolledTooltip>}
								</div>
							</div>
						}
						<div className="col-6">
							<div className={"form-group" + this.validateClass("defPriceSell")}>
								<label className="form-control-label">Birim Fiyat Satış</label>
								<NumberFormat id="defPriceSell"
											  value=
												  {(this.props.source && this.props.source==="despatchLines")
													  ?
													  (this.state.stock.defPriceSell === "0" || this.state.stock.defPriceSell === 0) ? "" : this.state.stock.defPriceSell
													  :
													  this.state.stock.defPriceSell
												  }
											  allowNegative={false}
											  isNumericString={true}
											  allowEmptyFormatting={false}
											  decimalScale={9}
											  thousandSeparator={'.'}
											  decimalSeparator={','}
											  displayType="input"
											 /* isAllowed={values => {
												  return (values.value === "" ? false : true);
											  }}*/
											  placeholder="Birim Fiyat Satış"
											  renderText={value => {
												  value.replace(/\./g, ',')
											  }}
											  suffix={this.state.symbol}
											  onValueChange={(e) => this.onChange({target:{value:e.value,name:"defPriceSell"}})}
											  className="form-control"/>
								{this.validateMessage("defPriceSell") !== "" &&
								<UncontrolledTooltip placement="right" target={"defPriceSell"} delay={0}>
									{this.validateMessage("defPriceSell")}
								</UncontrolledTooltip>}
							</div>
						</div>
						{!showBaro() &&
							<div className="col-6">
								<div className={"form-group" + this.validateClass("kdvPurchase")}>
									<label className="form-control-label">KDV Alış*</label>
									<NumberFormat id="kdvPurchase"
												  value={this.state.stock.kdvPurchase}
												  allowNegative={false}
												  isNumericString={true}
												  decimalScale={2}
												  allowEmptyFormatting={false}
												  thousandSeparator={'.'}
												  decimalSeparator={','}
												  displayType="input"
												  isAllowed={values => {
													  return (values.value === "" ? false : true);
												  }}
												  placeholder="KDV Alış"
												  renderText={value => {
													  value.replace(/\./g, ',')
												  }}
												  suffix="%"
												  onValueChange={(e) => this.onChange({
													  target: {
														  value: e.value,
														  name: "kdvPurchase"
													  }
												  })}
												  className="form-control"/>
									{this.validateMessage("kdvPurchase") !== "" &&
									<UncontrolledTooltip placement="right" target={"kdvPurchase"} delay={0}>
										{this.validateMessage("kdvPurchase")}
									</UncontrolledTooltip>}
								</div>
							</div>
						}
						<div className="col-6">
							<div className={"form-group" + this.validateClass("kdvSell")}>
								<label className="form-control-label">KDV Satış*</label>
								<NumberFormat id="kdvSell"
											  value={this.state.stock.kdvSell}
											  allowNegative={false}
											  isNumericString={true}
											  decimalScale={2}
											  allowEmptyFormatting={false}
											  thousandSeparator={'.'} decimalSeparator={','}
											  displayType="input"
											  isAllowed={values => {
												  return (values.value === "" ? false : true);
											  }}
											  placeholder="KDV Satış"
											  renderText={value => {
												  value.replace(/\./g, ',')
											  }}
											  suffix="%"
											  onValueChange={(e) => this.onChange({target:{value:e.value,name:"kdvSell"}})}
											  className="form-control"/>
								{this.validateMessage("kdvSell") !== "" &&
								<UncontrolledTooltip placement="right" target={"kdvSell"} delay={0}>
									{this.validateMessage("kdvSell")}
								</UncontrolledTooltip>}
							</div>
						</div>
						{ this.props.type === "voucher" &&
                        <div className="col-6">
                            <div className={"form-group" }>
                                <label className="form-control-label">GV Stopaj Alış</label>
                                <NumberFormat id="gvStoppagePurchase"
                                              value={this.state.stock.gvStoppagePurchase}
                                              allowNegative={false}
                                              isNumericString={true}
                                              decimalScale={2}
                                              allowEmptyFormatting={false}
                                              thousandSeparator={'.'} decimalSeparator={','}
                                              displayType="input"
                                              isAllowed={values => {
                                                  return (values.value === "" ? false : true);
                                              }}
                                              placeholder="GV Stopaj Alış"
                                              renderText={value => {
                                                  value.replace(/\./g, ',')
                                              }}
                                              suffix="%"
                                              onValueChange={(e) => this.onChange({target:{value:e.value,name:"gvStoppagePurchase"}})}
                                              className="form-control"/>
                                {this.validateMessage("gvStoppagePurchase") !== "" &&
                                <UncontrolledTooltip placement="right" target={"gvStoppagePurchase"} delay={0}>
                                    {this.validateMessage("gvStoppagePurchase")}
                                </UncontrolledTooltip>}
                            </div>
                        </div>}
                        { this.props.type === "voucher" &&
                        <div className="col-6">
                            <div className={"form-group" }>
                                <label className="form-control-label">GV Stopajı Satış</label>
                                <NumberFormat id="gvStoppageSell"
                                              value={this.state.stock.gvStoppageSell}
                                              allowNegative={false}
                                              isNumericString={true}
                                              decimalScale={2}
                                              allowEmptyFormatting={false}
                                              thousandSeparator={'.'} decimalSeparator={','}
                                              displayType="input"
                                              isAllowed={values => {
                                                  return (values.value === "" ? false : true);
                                              }}
                                              placeholder="GV Stopaj Satış"
                                              renderText={value => {
                                                  value.replace(/\./g, ',')
                                              }}
                                              suffix="%"
                                              onValueChange={(e) => this.onChange({target:{value:e.value,name:"gvStoppageSell"}})}
                                              className="form-control"/>
                                {this.validateMessage("gvStoppageSell") !== "" &&
                                <UncontrolledTooltip placement="right" target={"gvStoppageSell"} delay={0}>
                                    {this.validateMessage("gvStoppageSell")}
                                </UncontrolledTooltip>}
                            </div>
                        </div>
						}
						{ (new Decimal(this.state.stock.kdvPurchase).eq(new Decimal(0))) && this.props.exemptions && this.props.exemptions.length>0 &&
						<div className="col-6">
							<div className={"form-group" + this.validateClass("kdvPurchaseExemption")}>
								<label className="form-control-label">KDV Alış İstisna Sebebi*</label>
								<Select
									id="kdvPurchaseExemption"
									name="kdvPurchaseExemption"
									placeholder="İstisna Sebebi Seçiniz"
									value={this.state.stock.kdvPurchaseExemption}
									clearable={false}
									noResultsText="Sonuç yok"
									onChange={(e)=> e && this.onChange({target:{name:"kdvPurchaseExemption",value:e.value}})}
									options={this.props.exemptions.filter(exemption => exemption.exemptionType==="KDV").map(exemption => ({
										value: exemption.numberCode,
										label: exemption.longCode
									}))}
								/>
								{this.validateMessage("kdvPurchaseExemption") !== "" &&
								<UncontrolledTooltip placement="right" target={"kdvPurchaseExemption"} delay={0}>
									{this.validateMessage("kdvPurchaseExemption")}
								</UncontrolledTooltip>}
							</div>
						</div>
						}
						{ (new Decimal(this.state.stock.kdvSell).eq(new Decimal(0))) && this.props.exemptions && this.props.exemptions.length>0 &&
							<div className="col-6">
								<div className={"form-group" + this.validateClass("kdvSellExemption")}>
									<label className="form-control-label">KDV Satış İstisna Sebebi*</label>
									<Select
										id="kdvSellExemption"
										name="kdvSellExemption"
										placeholder="İstisna Sebebi Seçiniz"
										value={this.state.stock.kdvSellExemption}
										clearable={false}
										noResultsText="Sonuç yok"
										onChange={(e)=> e && this.onChange({target:{name:"kdvSellExemption",value:e.value}})}
										options={this.props.exemptions.filter(exemption => exemption.exemptionType==="KDV").map(exemption => ({
											value: exemption.numberCode,
											label: exemption.longCode
										}))}
									/>
									{this.validateMessage("kdvSellExemption") !== "" &&
									<UncontrolledTooltip placement="right" target={"kdvSellExemption"} delay={0}>
										{this.validateMessage("kdvSellExemption")}
									</UncontrolledTooltip>}
								</div>
							</div>
						}
						<div className="col-6" style={{display:'none'}}>
							<div className={"form-group" + this.validateClass("otv")}>
								<label className="form-control-label">ÖTV</label>
								<NumberFormat id="otv"
											  value={this.state.stock.otv}
											  allowNegative={false}
											  isNumericString={true}
											  allowEmptyFormatting={false}
											  decimalScale={2}
											  thousandSeparator={'.'}
											  decimalSeparator={','}
											  displayType="input"
											  isAllowed={values => {
												  return (values.value === "" ? false : true);
											  }}
											  placeholder="ÖTV"
											  renderText={value => {
												  value.replace(/\./g, ',')
											  }}
											  suffix="%"
											  onValueChange={(e) => this.onChange({target:{value:e.value,name:"otv"}})}
											  className="form-control"/>
								{this.validateMessage("otv") !== "" &&
								<UncontrolledTooltip placement="right" target={"otv"} delay={0}>
									{this.validateMessage("otv")}
								</UncontrolledTooltip>}
							</div>
						</div>
						<div className="col-6">
							<div className={"form-group" + this.validateClass("alias")}>
								<label className="form-control-label">Ürün/Hizmet Etiket</label>
								<input className="form-control"
									   type="text"
									   data-vlength="0,255"
									   id="alias"
									   name="alias"
									   onBlur={(e)=>this.validateField(e)}
									   onChange={this.onChange}
									   value={this.state.stock.alias}/>
								{this.validateMessage("alias") !== "" &&
								<UncontrolledTooltip placement="right" target={"alias"} delay={0}>
									{this.validateMessage("alias")}
								</UncontrolledTooltip>}
							</div>
						</div>
						<div className="col-6">
							<div className={"form-group" + this.validateClass("explanation")}>
								<label className="form-control-label">Ürün/Hizmet Açıklaması</label>
								<input className="form-control"
									   type="text"
									   data-vlength="0,255"
									   id="explanation"
									   name="explanation"
									   onBlur={(e)=>this.validateField(e)}
									   onChange={this.onChange}
									   value={this.state.stock.explanation}/>
								{this.validateMessage("explanation") !== "" &&
								<UncontrolledTooltip placement="right" target={"explanation"} delay={0}>
									{this.validateMessage("explanation")}
								</UncontrolledTooltip>}
							</div>
						</div>
						<div className="col-6">
							<div className={"form-group" + this.validateClass("gtip")}>
								<label className="form-control-label">GTİP Numarası</label>
								<input className="form-control"
									   type="text"
									   maxLength="12"
									   data-vlength={this.props.isGtipRequired===true?"12,12":"0,12"}
									   data-vdata="gtip"
									   id="gtip"
									   name="gtip"
									   onBlur={(e)=>this.validateField(e)}
									   onChange={this.onChange}
									   value={this.state.stock.gtip}/>
								{this.validateMessage("gtip") !== "" &&
								<UncontrolledTooltip placement="right" target={"gtip"} delay={0}>
									{this.validateMessage("gtip")}
								</UncontrolledTooltip>}
							</div>
						</div>

						{(this.props.type === "voucher" || (this.props.type === "invoice" && this.props.isTevkifat) || this.props.type === "stock") &&
						<div className="col-6">
							<div className={"form-group" }>
								<label className="form-control-label">KDV Tevkifatı</label>
								<Select
									id={"withHoldingCode"}
									name="withHoldingCode"
									value={this.state.stock.withHoldingCode}
									clearable={false}
									placeholder="Seçiniz..."
									noResultsText="Kayıt bulunamadı."
									onChange={(e)=>this.setWithholdingCode(e)}
									options={this.props.withholdingTypes.map(withholdingType => ({
										value: withholdingType.code+'_'+withholdingType.percentage,
										label: withholdingType.code +  ' - ' +(withholdingType.percentage / 10)+ "/10" + ' - ' + withholdingType.longName
									}))}
								/>
								{this.validateMessage("withHoldingCode") !== "" &&
								<UncontrolledTooltip placement="right" target={"withHoldingCode"} delay={0}>
									{this.validateMessage("withHoldingCode")}
								</UncontrolledTooltip>}
							</div>
						</div>
						}
					</div>
				</ModalBody>
				<ModalFooter>
					<nav className="col-sm-12" style={{paddingLeft:"0px", paddingRight:"0px"}}>
						<button type="button" className="col-sm-3 TekBtn vazgec"
								style={{ background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))',
										 padding: '9px 40px 9px 13px',float: 'left'}}
								onClick={this.isOpen}>İptal
						</button>

						<button type="button"
								style={{padding: '9px 39px 9px 13px', float: 'right'}}
								disabled={this.state.saveLoading}
								className="col-sm-3 TekBtn kaydet"
								onClick={(e) => this.saveStock(e)}>Kaydet
						</button>
					</nav>
				</ModalFooter>
			</Modal>
		);
	}
}

export default StockModal;

